"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.millisecondsToSecondsWithPrecision = exports.getDaysFromHours = exports.daysToMinutes = exports.minutesToDays = exports.formatDateTimeUtc = exports.printZonedDateTime = exports.printDateTime = exports.printDateTimeUtc = exports.todayUtc = exports.removeTimezoneShift = exports.MILLISECONDS_IN_DAY = exports.MonthIndexToName = exports.DateTimeFormat = void 0;
const tz_1 = require("@date-fns/tz");
const date_fns_1 = require("date-fns");
const lodash_1 = __importDefault(require("lodash"));
const num_1 = require("./num");
var DateTimeFormat;
(function (DateTimeFormat) {
    DateTimeFormat["DATE"] = "yyyy-MM-dd";
    DateTimeFormat["TIME"] = "HH:mm";
    DateTimeFormat["TIME_SECONDS"] = "HH:mm:ss";
    DateTimeFormat["DATE_TIME"] = "yyyy-MM-dd HH:mm";
    DateTimeFormat["DATE_TIME_SECONDS"] = "yyyy-MM-dd HH:mm:ss";
})(DateTimeFormat || (exports.DateTimeFormat = DateTimeFormat = {}));
exports.MonthIndexToName = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
];
exports.MILLISECONDS_IN_DAY = 1000 * 60 * 60 * 24;
const removeTimezoneShift = (value) => {
    return (0, date_fns_1.addMinutes)(value, value.getTimezoneOffset());
};
exports.removeTimezoneShift = removeTimezoneShift;
exports.todayUtc = (0, exports.removeTimezoneShift)(new Date());
const printDateTimeUtc = (inputDate, format) => {
    return printFormattedDate((0, exports.removeTimezoneShift)(new Date(inputDate)), format);
};
exports.printDateTimeUtc = printDateTimeUtc;
const printDateTime = (inputDate, format) => {
    return printFormattedDate(new Date(inputDate), format);
};
exports.printDateTime = printDateTime;
const printZonedDateTime = (date, timezone) => {
    const zonedTime = (0, date_fns_1.transpose)(new tz_1.TZDate(date, timezone), tz_1.TZDate);
    return `${(0, date_fns_1.format)(zonedTime, "EEE")}, ${(0, exports.printDateTime)(zonedTime, DateTimeFormat.DATE_TIME)}`;
};
exports.printZonedDateTime = printZonedDateTime;
const formatDateTimeUtc = (inputDate, format) => {
    return (0, date_fns_1.format)((0, exports.removeTimezoneShift)(inputDate), format);
};
exports.formatDateTimeUtc = formatDateTimeUtc;
const minutesToDays = (minutes) => {
    return (0, num_1.round)(minutes / 1440, 3);
};
exports.minutesToDays = minutesToDays;
const daysToMinutes = (hours) => {
    return (0, num_1.round)(hours * 1440);
};
exports.daysToMinutes = daysToMinutes;
const getDaysFromHours = (hours) => {
    return lodash_1.default.round(hours / 24, 1);
};
exports.getDaysFromHours = getDaysFromHours;
const millisecondsToSecondsWithPrecision = (milliseconds, precision = 2) => {
    const precisionFactor = Math.pow(10, precision);
    return Math.round((milliseconds / 1000) * precisionFactor) / precisionFactor;
};
exports.millisecondsToSecondsWithPrecision = millisecondsToSecondsWithPrecision;
const printFormattedDate = (date, format) => {
    if (format === DateTimeFormat.DATE_TIME) {
        return `${(0, date_fns_1.format)(date, DateTimeFormat.DATE)} at ${(0, date_fns_1.format)(date, DateTimeFormat.TIME)}`;
    }
    if (format === DateTimeFormat.DATE_TIME_SECONDS) {
        return `${(0, date_fns_1.format)(date, DateTimeFormat.DATE)} at ${(0, date_fns_1.format)(date, DateTimeFormat.TIME_SECONDS)}`;
    }
    return (0, date_fns_1.format)(date, format);
};
//# sourceMappingURL=date.js.map